type ApplicationFilePresentationSource = {
  downloadUrl?: null | string;
  id?: null | string;
  url?: null | string;
};

const PRIVATE_VERCEL_BLOB_HOST_SUFFIX = ".private.blob.vercel-storage.com";
const PUBLIC_VERCEL_BLOB_HOST_SUFFIX = ".public.blob.vercel-storage.com";

export function isPrivateVercelBlobUrl(value: null | string | undefined): boolean {
  if (!value) return false;

  try {
    return new URL(value).hostname.endsWith(PRIVATE_VERCEL_BLOB_HOST_SUFFIX);
  } catch {
    return false;
  }
}

export function getApplicationFilePresentationUrl(
  file: ApplicationFilePresentationSource | null | undefined,
  mode: "download" | "view" = "view",
): null | string {
  if (!file) return null;

  const sourceUrl = mode === "download"
    ? file.downloadUrl || file.url
    : file.url || file.downloadUrl;
  if (!sourceUrl) return null;

  if (file.id && isPrivateVercelBlobUrl(sourceUrl)) {
    const route = `/api/application-files/${encodeURIComponent(file.id)}`;
    return mode === "download" ? `${route}?download=1` : route;
  }

  if (mode === "download" && !file.downloadUrl) {
    try {
      const url = new URL(sourceUrl);
      if (url.hostname.endsWith(PUBLIC_VERCEL_BLOB_HOST_SUFFIX)) {
        url.searchParams.set("download", "1");
        return url.href;
      }
    } catch {
      // Relative and local file URLs keep their existing presentation contract.
    }
  }

  return sourceUrl;
}
